'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var BufferList = require('bl/BufferList.js');

var rabinWasm = require('rabin-wasm');

var errCode = require('err-code');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var BufferList__default = /*#__PURE__*/_interopDefaultLegacy(BufferList);

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

function rabinChunker(_x, _x2) {
  return _rabinChunker.apply(this, arguments);
}

function _rabinChunker() {
  _rabinChunker = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source, options) {
    var min, max, avg, sizepow, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, chunk;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(options.minChunkSize && options.maxChunkSize && options.avgChunkSize)) {
              _context.next = 6;
              break;
            }

            avg = options.avgChunkSize;
            min = options.minChunkSize;
            max = options.maxChunkSize;
            _context.next = 13;
            break;

          case 6:
            if (options.avgChunkSize) {
              _context.next = 10;
              break;
            }

            throw errCode__default['default'](new Error('please specify an average chunk size'), 'ERR_INVALID_AVG_CHUNK_SIZE');

          case 10:
            avg = options.avgChunkSize;
            min = avg / 3;
            max = avg + avg / 2;

          case 13:
            if (!(min < 16)) {
              _context.next = 15;
              break;
            }

            throw errCode__default['default'](new Error('rabin min must be greater than 16'), 'ERR_INVALID_MIN_CHUNK_SIZE');

          case 15:
            if (max < min) {
              max = min;
            }

            if (avg < min) {
              avg = min;
            }

            sizepow = Math.floor(Math.log2(avg));
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 20;
            _iterator = _asyncIterator(rabin(source, {
              min: min,
              max: max,
              bits: sizepow,
              window: options.window,
              polynomial: options.polynomial
            }));

          case 22:
            _context.next = 24;
            return _awaitAsyncGenerator(_iterator.next());

          case 24:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 31;
              break;
            }

            chunk = _step.value;
            _context.next = 28;
            return chunk;

          case 28:
            _iteratorAbruptCompletion = false;
            _context.next = 22;
            break;

          case 31:
            _context.next = 37;
            break;

          case 33:
            _context.prev = 33;
            _context.t0 = _context["catch"](20);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 37:
            _context.prev = 37;
            _context.prev = 38;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context.next = 42;
              break;
            }

            _context.next = 42;
            return _awaitAsyncGenerator(_iterator.return());

          case 42:
            _context.prev = 42;

            if (!_didIteratorError) {
              _context.next = 45;
              break;
            }

            throw _iteratorError;

          case 45:
            return _context.finish(42);

          case 46:
            return _context.finish(37);

          case 47:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[20, 33, 37, 47], [38,, 42, 46]]);
  }));
  return _rabinChunker.apply(this, arguments);
}

function rabin(_x3, _x4) {
  return _rabin.apply(this, arguments);
}

function _rabin() {
  _rabin = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(source, options) {
    var r, buffers, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, chunk, sizes, i, size, buf;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _awaitAsyncGenerator(rabinWasm.create(options.bits, options.min, options.max, options.window));

          case 2:
            r = _context2.sent;
            buffers = new BufferList__default['default']();
            _iteratorAbruptCompletion2 = false;
            _didIteratorError2 = false;
            _context2.prev = 6;
            _iterator2 = _asyncIterator(source);

          case 8:
            _context2.next = 10;
            return _awaitAsyncGenerator(_iterator2.next());

          case 10:
            if (!(_iteratorAbruptCompletion2 = !(_step2 = _context2.sent).done)) {
              _context2.next = 27;
              break;
            }

            chunk = _step2.value;
            buffers.append(chunk);
            sizes = r.fingerprint(chunk);
            i = 0;

          case 15:
            if (!(i < sizes.length)) {
              _context2.next = 24;
              break;
            }

            size = sizes[i];
            buf = buffers.slice(0, size);
            buffers.consume(size);
            _context2.next = 21;
            return buf;

          case 21:
            i++;
            _context2.next = 15;
            break;

          case 24:
            _iteratorAbruptCompletion2 = false;
            _context2.next = 8;
            break;

          case 27:
            _context2.next = 33;
            break;

          case 29:
            _context2.prev = 29;
            _context2.t0 = _context2["catch"](6);
            _didIteratorError2 = true;
            _iteratorError2 = _context2.t0;

          case 33:
            _context2.prev = 33;
            _context2.prev = 34;

            if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
              _context2.next = 38;
              break;
            }

            _context2.next = 38;
            return _awaitAsyncGenerator(_iterator2.return());

          case 38:
            _context2.prev = 38;

            if (!_didIteratorError2) {
              _context2.next = 41;
              break;
            }

            throw _iteratorError2;

          case 41:
            return _context2.finish(38);

          case 42:
            return _context2.finish(33);

          case 43:
            if (!buffers.length) {
              _context2.next = 46;
              break;
            }

            _context2.next = 46;
            return buffers.slice(0);

          case 46:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[6, 29, 33, 43], [34,, 38, 42]]);
  }));
  return _rabin.apply(this, arguments);
}

module.exports = rabinChunker;